module.exports = __webpack_public_path__ + "img/recommend2-1.53728ea0.png";